import { useEffect, useState } from 'react';
import { useOperator } from '../../contexts/OperatorContext';
import { formatDateStringWithTimeZone } from '../../lib/dateHelpers';
import { BASE_URL_MAP } from '../../lib/environment';
import {
  HosApiDashboardMessaging,
  ResApiDashboardMessaging,
} from '../../types/apiTypes';
import {
  DashboardCardTimespan,
  DashboardDataMessaging,
  DashboardDataMessagingRes,
} from '../../types/commonTypes';
import { useFetch } from '../useFetch';

export const useMessagingAnalytics = () => {
  const [messagingAnalytics, setMessagingAnalytics] = useState<
    DashboardDataMessaging[] | DashboardDataMessagingRes[]
  >([]);
  const { makeRequest, loading, response } = useFetch();
  const operator = useOperator();
  const isRes = operator?.type === 'Residential' ?? false;

  useEffect(() => {
    if (response && !loading) {
      isRes
        ? setMessagingAnalytics(mapMessagingAnalyticsRes(response))
        : setMessagingAnalytics(mapMessagingAnalytics(response));
    }
  }, [response, loading]);

  const getMessagingAnalytics = (dateRange?: DashboardCardTimespan) => {
    let url = `${BASE_URL_MAP[operator.type]}/${operator?.id}${
      isRes ? '' : '/Dashboard'
    }/Messages`;
    if (dateRange)
      url += `?startDate=${dateRange.startDate.toISOString()}&endDate=${dateRange.endDate.toISOString()}`;

    makeRequest(url, 'get');
  };

  return { messagingAnalytics, getMessagingAnalytics, loading };
};

const mapMessagingAnalytics = (
  messages: HosApiDashboardMessaging[]
): DashboardDataMessaging[] => {
  return messages.map((message: HosApiDashboardMessaging) => {
    return {
      id: message.Disposition,
      value: message.Count,
      percentRead: message.PercentRead,
    };
  });
};

const mapMessagingAnalyticsRes = (
  messages: ResApiDashboardMessaging[]
): DashboardDataMessagingRes[] => {
  return messages.map((message: ResApiDashboardMessaging) => {
    return {
      id: message.Subject,
      value: message.TotalRead,
      messageId: message.MessageID,
      startDate: formatDateStringWithTimeZone(new Date(message.StartDate)),
      subject: message.Subject,
      totalHits: message.TotalHits,
      totalRead: message.TotalRead,
      totalSent: message.TotalSent,
    };
  });
};
